import { escapeHtml } from '../../utils/lodash-replacements';
import { getProductInventories } from '../../core/productInfo';

// TODO: Refactor this function to use new PDP Redesign approach once QuickView has been rebuilt
export default (product_details) => {
  setTimeout(() => {
    const product_reviews = document.querySelector('[data-reviews-average]')?.dataset;
    let product_inventories = getProductInventories();
    if (!product_inventories) {
      // New PDP Redesign
      const inventoryElement = document.querySelector('[data-inventory-json]');
      product_inventories = JSON.parse(decodeURIComponent(inventoryElement.getAttribute('data-inventory-json')));
    }
    // If customer navigates in PDP, i.e: https://store.com/collections/dresses/products/something we can assign collectionName
    let collectionName = window.theme.collection || window.theme.collectionName || '';
    const hasBreadCrumbLinks =
      product_details.container?.querySelector('.Breadcrumb__link>a:last-child') ||
      product_details.container?.querySelector('.Breadcrumb__link:last-child') ||
      document.querySelector('.pdp-l-breadcrumbs a:last-of-type');

    if (!collectionName && hasBreadCrumbLinks) {
      // It's helpful in two possible scenarios
      // 1. In case customer was redirected from a Quick View and ended up clicking Product Title link there
      // 2. if customer is navigating in PDP like https://store.com/products/something
      collectionName = hasBreadCrumbLinks.textContent || '';
    }

    // Only if Quick View is open
    if (product_details.container?.closest('.QuickView__content')) {
      collectionName = hasBreadCrumbLinks?.textContent || '';
    }

    const admind_product = {
      id: product_details.product.id,
      variant: product_details.currentVariant.id,
      style: escapeHtml(product_details.currentVariant.barcode),
      // category: ,
      subcategory: escapeHtml(product_details.product.type),
      name: escapeHtml(product_details.product.title),
      price: Number((product_details.currentVariant.price / 100).toFixed(2)),
      originalPrice: Number((product_details.currentVariant.compare_at_price / 100).toFixed(2)),
      newArrival: product_details.product.tags.includes('New Arrival'),
      isMarkedDown: product_details.currentVariant.price < product_details.currentVariant.compare_at_price,
      hasReviews: parseInt(product_reviews?.reviewsCount) > 0 || false,
      reviewCount: parseInt(product_reviews?.reviewsCount) || 0,
      reviewAverage: parseFloat(product_reviews?.reviewsAverage) || 0,
      showsQuadpay: product_details.currentVariant.price > 1900,
      almostGone: product_inventories[product_details.currentVariant.id] < 10,
      list: collectionName || '',
    };

    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: 'detail',
      ecommerce: {
        detail: {
          products: [admind_product],
        },
      },
    });
  });
};
